// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9bc02cfe","369":"65991583","787":"8c6ad859","921":"d7e38f64"}[chunkId] + ".chunk.js";
};